import React, { useEffect, useState } from 'react'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import { Accordion, AccordionDetails, AccordionSummary, Box, MenuItem, Typography } from '@mui/material'
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FilterSelect from '../../../components/select/filterSelect';
import InputTextField from '../../../components/input/inputTextField';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Paper,
} from "@mui/material";
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import { CourseApi } from '../../../api/course/course.api';
import AutocompleteSelect from '../../../components/select/autoCompleteSelect';
import ModalCustom from '../../../components/modal/ModalCustom';
import { advisorApi } from '../../../api/advisor/advisor.api';
import { advisorTypeApi } from '../../../api/advisor-type/advisor-type.api';
import { advisorFormApi } from '../../../api/advisor-form/advisor-form.api';
import { CourseAnnualApi } from '../../../api/course-annual/course-annual.api';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { EmployeeApi } from '../../../api/employee/employee.api';
import { useTranslation } from 'react-i18next';



const days: any[] = [
    "อาทิตย์",
    "จันทร์",
    "อังคาร",
    "พุธ",
    "พฤหัสบดี",
    "ศุกร์",
    "เสาร์",
];

const timeSlots = [
    "08:30 - 09:30",
    "09:30 - 10:30",
    "10:30 - 11:30",
    "11:30 - 12:30",
    "12:30 - 13:30",
    "13:30 - 14:30",
    "14:30 - 15:30",
    "15:30 - 16:30",
    "16:30 - 17:30",
    "17:30 - 18:30",
    "18:30 - 19:30",
];


export default function CourseOfStudyAddSubject() {
    const { id, idDetail } = useParams();
    const location = useLocation();
    const navigate = useNavigate()
    const { t } = useTranslation();

    const search_params = new URLSearchParams(location.search);
    const academic_year = search_params.get("academic_year");
    const term = search_params.get("term");
    const mode = search_params.get("mode");
    const [open, setOpen] = useState<boolean>(false)
    const [detail, setDetail] = useState<any>()
    const [form, setForm] = useState<any>()
    const [courseAnnual, setCourseAnnual] = useState<any>()
    const [type, setType] = useState<any>(false)
    const [cousre, setCousre] = useState<any[]>([])
    const [advisor, setAdvisor] = useState<any[]>([])
    const [advisorForm, setAdvisorForm] = useState<any[]>([])
    const [advisorType, setAdvisorType] = useState<any[]>([{ id_advisor_type: 'LEAD_INSTRUCTOR', advisor_type_name: 'อาจารย์ผู้สอนหลัก' }, { id_advisor_type: 'CO_INSTRUCTOR', advisor_type_name: 'อาจารย์ผู้สอนร่วม' }, { id_advisor_type: 'MAIN_ADVISOR', advisor_type_name: 'อาจารย์ที่ปรึกษาหลัก' }, { id_advisor_type: 'CO_ADVISOR', advisor_type_name: 'อาจารย์ที่ปรึกษาร่วม' }])
    // const [checked, setChecked] = useState<any>(
    //     Array.from({ length: days.length }, () => Array(timeSlots.length).fill(false))
    // );

    const [checked, setChecked] = useState<{ study_day: number; study_course_period: number }[]>([]);

    const handleCheck = (dayIndex: number, timeIndex: number) => {
        setChecked((prevChecked: any) => {
            const index = prevChecked.findIndex(
                (item: any) => item.study_day === dayIndex && item.study_course_period === timeIndex
            );

            if (index !== -1) {
                // ถ้าพบในรายการ ให้ลบออก
                return prevChecked.filter((_: any, i: any) => i !== index);
            } else {
                // ถ้าไม่พบ ให้เพิ่มเข้าไป
                return [...prevChecked, { study_day: dayIndex, study_course_period: timeIndex }];
            }
        });
    };
    const getDetail = async () => {
        const res = await CourseOfStudyApi.findById(id);
        const data = res.data;
        if (data.status < 300) {
            setDetail(data.data);
        } else {
            setDetail(null);
        }
    }
    const getCousre = async () => {
        let condition: any = {
            page: 1,
            limit: 100,
            status: 'active'
        };

        const res = await CourseApi.list(condition);
        const data = res.data;
        if (data.status < 300) {
            setCousre(data.data.items);
        } else {
            setCousre([]);
        }
    }
    const getAdvisor = async () => {
        let condition: any = {
            page: 1,
            limit: 100,
        };

        const res = await EmployeeApi.list(condition);
        const data = res.data;
        if (data.status < 300) {
            setAdvisor(data.data.items);
        } else {
            setAdvisor([]);
        }
    }
    const getAdvisorForm = async () => {
        let condition: any = {
            page: 1,
            limit: 100,
        };

        const res = await advisorFormApi.getAllAdvisorForm(condition);
        const data = res.data;
        if (data.status < 300) {
            setAdvisorForm(data.data.items);
        } else {
            setAdvisorForm([]);
        }
    }
    const getAdvisorType = async () => {
        let condition: any = {
            page: 1,
            limit: 100,
        };

        const res = await advisorTypeApi.getAllAdvisorType(condition);
        const data = res.data;
        if (data.status < 300) {
            setAdvisorType(data.data.items);
        } else {
            setAdvisorType([]);
        }
    }

    const fetchGetRoomAcademicYear = async (id: number) => {
        const res = await CourseOfStudyApi.academicDetail(id)
        const data = res.data;
        if (data.status < 300) {
            // const uniqueDegree = res.data.data.reduce((acc: any[], curr: any) => {
            //     if (!acc.some(item => item.id_degree === curr.id_degree)) {
            //         acc.push({
            //             id_degree: curr.id_degree, // ถ้า null ให้เป็น 5
            //             degree_name: curr.degree_name,
            //             degree_name_eng: curr.degree_name_eng,
            //         });
            //     }
            //     return acc;
            // }, []);

            // setDataDegreeAcademicYear(uniqueDegree);
        } else {
            // setDataDegreeAcademicYear([]);
        }
    };
    const findById = async () => {

        const res = await CourseAnnualApi.findById(idDetail);
        const data = res.data;
        if (data.status < 300) {
            setForm(data.data);
            setChecked(data.data?.course_study_day?.map((item: any, index: number) => {
                return {
                    study_day: item?.study_day,
                    study_course_period: item?.study_course_period > 4 ? item?.study_course_period : item?.study_course_period - 1
                }
            }))
        } else {
            setForm(null);
        }
    }
    useEffect(() => {
        getDetail()
        getCousre()
        getAdvisor()
        getAdvisorForm()
        // getAdvisorType()
        if (idDetail) {
            findById()
        }
    }, [])

    const handleSubmit = async () => {
        const body = {
            id_course_of_study: id,
            academic_year: academic_year,
            term: term,
            room: form?.room,
            id_courses: form?.courses?.id_courses,
            id_advisor_form: form?.id_advisor_form,
            status: "active",
            // course_annual_status: "DRAFT",
            course_study_days: checked?.map((item: any, index: number) => {
                return {
                    study_day: item?.study_day,
                    study_course_period: item?.study_course_period > 3 ? item?.study_course_period : item?.study_course_period + 1
                }
            }),
            course_annual_employees: form?.course_annual_employee?.map((item: any) => {
                return {
                    id_employee: item?.id_employee,
                    position_annual: item?.position_annual
                }
            }),
        }
        if (!mode && idDetail) {
            await CourseAnnualApi.patch(body, idDetail).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('COUNRSE_OF_STUDT.EDIT_COURSE_SUCCESS'))
                    findById()

                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })
        } else {
            await CourseAnnualApi.post(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('COUNRSE_OF_STUDT.ADD_COURSE_SUCCESS'))
                    navigate(
                        routeName.cms.CourseOfStudyDetail.replace(':id', id || '')
                    );

                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })
        }


    }
    console.log(form?.advisor);

    return (
        <div className="h-auto">
            {/* breadcrumbs */}
            <NavigateListCustom
                navigateData={[
                    {
                        name: `${t("COUNRSE_OF_STUDT.MANAGE_SCHEDULE")}`,
                        key: "1",
                        pathName: routeName.cms.CourseofStudy,
                    },
                    {
                        name: `${t('COUNRSE_OF_STUDT.ACADEMIC_YEAR')} ${detail?.academic_year} ${t("COUNRSE_OF_STUDT.SEMESTER")} ${detail?.semester || ''} ${t("COUNRSE_OF_STUDT.LEVEL")} ${detail?.degree?.degree_name || ''} ${t("COUNRSE_OF_STUDT.FACULTY")} ${detail?.faculty?.faculty_name}`,
                        key: "2",
                        pathName: '',
                    },
                    {
                        name: `${t('COUNRSE_OF_STUDT.YEAR_LEVEL')} 1`,
                        key: "3",
                        pathName: '',
                    },
                    {
                        name: `${t("COUNRSE_OF_STUDT.ADD_COURSE")}`,
                        key: "4",
                        pathName: '',
                    },
                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">{mode === 'VIEW' ? t('COUNRSE_OF_STUDT.COURSE_INFO') : mode === 'COPY' ? t('COUNRSE_OF_STUDT.COPY_COURSE') : idDetail ? t('COUNRSE_OF_STUDT.EDIT_COURSE') : t('COUNRSE_OF_STUDT.ADD_COURSE')}</Typography>
            </section>
            <div className="w-full grid grid-cols-12 gap-4 my-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    {/* <InputTextField
                        heading={t('COUNRSE_OF_STUDT.ROOM')}
                        placeholder=""
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setForm({ ...form, room: e.target.value })
                        }}
                        value={form?.room}
                        disabled={mode === 'VIEW'}

                    /> */}
                    <FilterSelect
                        style={{ padding: 0 }}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setForm({ ...form, room: e.target.value })
                        }}
                        value={form?.room || ''}
                        labelId={"1"}
                        heading={t('COUNRSE_OF_STUDT.ROOM')}
                        selectId={"1"}
                        options={detail?.room?.split(',')?.map((x: any) => {
                            return (
                                <MenuItem value={x} key={x}>
                                    {x}
                                </MenuItem>
                            )
                        })}
                        disabled={mode === 'VIEW'}
                    />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-6 sm:col-span-12">
                    {/* <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        heading='รายวิชา'
                        labelId="year-id"
                        selectId="year-select-id"
                        options={cousre.map((year: any, index: number) => (
                            <MenuItem value={year.id_courses} key={index + 1}>
                                {year.courses_name}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    /> */}
                    <AutocompleteSelect
                        heading={t('COUNRSE_OF_STUDT.COURSE_NAME')} placeholder={t('COUNRSE_OF_STUDT.COURSE_NAME')}
                        freeSolo
                        labelId={''} options={cousre}
                        getOptionLabel={(option: any) => `${option?.courses_name}` || ""}
                        onChange={(e: any, value: any) => {
                            setForm({ ...form, id_courses: value?.id_courses, courses: value })
                        }}
                        value={form?.courses || null}
                        disabled={mode === 'VIEW'}
                    />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <InputTextField
                        heading={t('COUNRSE_OF_STUDT.COURSE_CODE')}
                        placeholder=""
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                        }}
                        value={form?.courses?.courses_no || ''}
                        disabled
                    />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <InputTextField
                        heading={t('COUNRSE_OF_STUDT.CREDIT')}
                        placeholder=""
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                        }}
                        value={form?.courses?.credits || ''}
                        disabled
                    />
                </article>

            </div>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>{t('COUNRSE_OF_STUDT.PERIOD')}</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>1</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>2</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>3</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>4</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>{t('COUNRSE_OF_STUDT.LUNCH_BREAK')}</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>5</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>6</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>7</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>8</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>9</TableCell>
                            <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff" }}>10</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>{t('COUNRSE_OF_STUDT.DAY_TIME')}</TableCell>
                            {timeSlots.map((slot, index) => (
                                <TableCell key={index} sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                                    {slot}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {days.map((day, dayIndex) => (
                            <TableRow key={dayIndex}>
                                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>{day}</TableCell>
                                {timeSlots.map((_, timeIndex) => (
                                    <TableCell key={timeIndex} sx={{ textAlign: "center" }}>
                                        {timeIndex === 4 ? (
                                            <div style={{ backgroundColor: "#e0e0e0", height: "100%", width: "100%" }}></div>
                                        ) : (
                                            <Checkbox
                                                checked={checked.some((item: any) => item.study_day === dayIndex && item.study_course_period === timeIndex)}
                                                onChange={() => handleCheck(dayIndex, timeIndex)}
                                                color="success"
                                                disabled={mode === 'VIEW'}
                                            />
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Typography sx={{ margin: '40px 0px 0px 0px' }}>{t('COUNRSE_OF_STUDT.LECTURER_ADVISOR')}</Typography>
            <Accordion defaultExpanded sx={{ backgroundColor: "#f9a825", color: "white", borderRadius: "8px" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    aria-controls="panel1-content"
                    id="panel1-header"

                    sx={{
                        backgroundColor: "#f9a825",
                        padding: "10px 16px",
                        fontWeight: "bold",
                    }}
                >
                    <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', }}>
                        <Typography sx={{ fontWeight: "bold", width: '40%' }}>{t('COUNRSE_OF_STUDT.FULL_NAME')}</Typography>
                        <Typography sx={{ fontWeight: "bold", width: '50%' }}>{t('COUNRSE_OF_STUDT.TYPE')}</Typography>
                    </Box>
                    {/* <ButtonPrimary
                        onClick={() => {



                        }}
                        mode="add"
                        buttonName={"เพิ่ม"}
                    /> */}
                    {mode !== 'VIEW' && <Box sx={{ background: "#fff", border: '1px solid #7e7e7e', borderRadius: '8px', padding: '5px 10px' }}>
                        <Typography onClick={(e) => {
                            e.stopPropagation()
                            setOpen(true)
                            setType(false)

                            setForm({ ...form, advisor: { fullname: '' }, position_annual: '' })

                        }}>เพิ่ม</Typography>
                    </Box>}
                </AccordionSummary>
                <AccordionDetails sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {form?.course_annual_employee?.length > 0 ? form?.course_annual_employee?.map((item: any, index: number) => {
                        return (
                            <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', boxShadow: '0px 0px 4px 0px #10182829', padding: '10px', borderRadius: '8px' }} >
                                <Typography sx={{ width: '37%' }}>{item?.fullname || `${item?.employee?.first_name} ${item?.employee?.last_name}`}</Typography>
                                <Typography sx={{ width: '50%' }}>{advisorType?.find((x: any) => item?.position_annual === x?.id_advisor_type)?.advisor_type_name}</Typography>
                                <OptionsButtonCustom
                                    enableView={mode !== 'VIEW'}
                                    // enableEdit={mode !== 'VIEW'}
                                    enableDelete={mode !== 'VIEW'}
                                    onViewClick={() => {
                                        setOpen(true)
                                        setType(true)
                                        setForm({ ...form, advisor: { ...item.employee, fullname: item?.fullname || `${item?.employee?.first_name} ${item?.employee?.last_name}` }, position_annual: item?.position_annual })
                                    }}
                                    onCopy={() => {

                                    }}
                                    onEditClick={() => {
                                        setOpen(true)
                                        setType(false)
                                        setForm({ ...form, advisor: { ...item.employee, fullname: item?.fullname || `${item?.employee?.first_name} ${item?.employee?.last_name}` }, position_annual: item?.position_annual })
                                    }}
                                    onDeleteClick={() => {
                                        setForm({ ...form, course_annual_employee: form?.course_annual_employee?.filter((x: any, i: number) => i !== index) })
                                    }} />
                            </Box>
                        )
                    }) : <Typography>ไม่มีข้อมูล...</Typography>}

                </AccordionDetails>
            </Accordion>
            <div style={{
                margin: '40px 0px'
            }}>
                {/* <InputTextField heading='แบบฟอร์มประเมินแบบฟอร์มประเมินอาจารย์ผู้สอน' /> */}
                <FilterSelect
                    // value={inputValueSearch.year ?? ""}
                    heading={t('COUNRSE_OF_STUDT.EVALUATION_FORM')}
                    labelId="year-id"
                    selectId="year-select-id"
                    options={advisorForm?.filter((x: any) => x?.is_teacher !== '0')?.map((item: any, index: number) => (
                        <MenuItem value={item.id_advisor_form} key={index + 1}>
                            {item.advisor_form_name}
                        </MenuItem>
                    ))}
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setForm({ ...form, id_advisor_form: e.target.value })
                    }}
                    value={form?.id_advisor_form || ''}
                    disabled={mode === 'VIEW'}
                />
            </div>
            <div className='flex justify-center gap-4'>
                <ButtonBack
                    onClick={() => {
                        navigate(-1)
                    }}
                    buttonName={'ยกเลิก'}
                />
                {mode !== 'VIEW' &&
                    <ButtonPrimary
                        onClick={() => {
                            handleSubmit()
                        }}
                        mode='add'
                        buttonName={'ยืนยัน'}
                    />}
            </div>

            <ModalCustom title={t('COUNRSE_OF_STUDT.ADD_LECTURER_ADVISOR')} subTitle={t('COUNRSE_OF_STUDT.SUBTITLE')} open={open} component={
                <div className='flex flex-col gap-4'>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <AutocompleteSelect
                            heading={t('COUNRSE_OF_STUDT.LECTURER_NAME')} placeholder={t('COUNRSE_OF_STUDT.LECTURER_NAME')}
                            freeSolo
                            labelId={''} options={advisor}
                            getOptionLabel={(option: any) => `${option?.fullname}` || ""}
                            onChange={(e: any, value: any) => {
                                setForm({ ...form, advisor: value })
                            }}
                            value={form?.advisor || ''}
                            disabled={type}
                        />
                    </article>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <FilterSelect
                            // value={inputValueSearch.year ?? ""}
                            heading={t('COUNRSE_OF_STUDT.TYPE')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={advisorType.map((item: any, index: number) => (
                                <MenuItem value={item.id_advisor_type} key={index + 1}>
                                    {item.advisor_type_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, position_annual: e.target.value })
                            }}
                            value={form?.position_annual}
                            disabled={type}

                        />
                        {/* <FilterSelect
                            // value={inputValueSearch.year ?? ""}
                            heading='ประเภท'
                            labelId="year-id"
                            selectId="year-select-id"
                            options={advisorType.map((item: any, index: number) => (
                                <MenuItem value={item.id_advisor_type} key={index + 1}>
                                    {item.advisor_type_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                                // handleChangeValueSearch("year", e.target.value)
                            }
                        /> */}
                    </article>

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                                setForm({ ...form, advisor: null, position_annual: '' })

                            }}
                            buttonName={'ยกเลิก'}
                        />
                        {!type && <ButtonPrimary
                            onClick={() => {
                                setForm({ ...form, course_annual_employee: form?.course_annual_employee?.length > 0 ? [...form?.course_annual_employee, { ...form?.advisor, position_annual: form?.position_annual }] : [{ ...form?.advisor, position_annual: form?.position_annual }], advisor: null, position_annual: '' })
                                setOpen(false)
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />}
                    </div>
                </div>
            } />

        </div>
    )
}
